import { render, staticRenderFns } from "./dialog-form-wrapper.vue?vue&type=template&id=7a995e46&scoped=true"
import script from "./dialog-form-wrapper.vue?vue&type=script&lang=js"
export * from "./dialog-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a995e46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a995e46')) {
      api.createRecord('7a995e46', component.options)
    } else {
      api.reload('7a995e46', component.options)
    }
    module.hot.accept("./dialog-form-wrapper.vue?vue&type=template&id=7a995e46&scoped=true", function () {
      api.rerender('7a995e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/conversations/send-list/dialog-form-wrapper.vue"
export default component.exports